module.exports = __webpack_public_path__ + "img/sprava-uzivatelu.4e2b39e8.svg";